export var ConnectionTypes;
(function(ConnectionTypes) {
  ConnectionTypes[(ConnectionTypes["SSH"] = 0)] = "SSH";
  ConnectionTypes[(ConnectionTypes["RDP"] = 1)] = "RDP";
  ConnectionTypes[(ConnectionTypes["PS"] = 2)] = "PS";
  ConnectionTypes[(ConnectionTypes["WRDP"] = 3)] = "WRDP"; // Windows RDP
})(ConnectionTypes || (ConnectionTypes = {}));
export var MachineType;
(function(MachineType) {
  MachineType[(MachineType["Linux"] = 717580000)] = "Linux";
  MachineType[(MachineType["Window"] = 717580001)] = "Window";
  MachineType[(MachineType["Ubuntu"] = 717580002)] = "Ubuntu";
})(MachineType || (MachineType = {}));
//# sourceMappingURL=enums.js.map
